import React, { useState } from "react";
import { CalendarCheck, Search } from "lucide-react";
import Layout from "../components/Layout";
import api from "../api";
import useSeo from "../hooks/useSeo";

const toDisplay = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}-${m}-${y}`;
};

const TeerCalendar = () => {
  useSeo(
    "Morning Sunday Teer Calendar | Shillong Morning Teer Result by Date",
    "Morning Teer Calendar — pick any date to view the Shillong Morning Teer F/R and S/R result declared on that day."
  );
  const [dateISO, setDateISO] = useState("");
  const [result, setResult] = useState(undefined); // undefined=not searched
  const [loading, setLoading] = useState(false);

  const search = async (e) => {
    e.preventDefault();
    if (!dateISO) return;
    setLoading(true);
    try {
      const r = await api.getCalendar(toDisplay(dateISO));
      setResult(r);
    } catch (e) {
      setResult(null);
    }
    setLoading(false);
  };

  return (
    <Layout title="Teer Calendar">
      <div className="max-w-3xl mx-auto px-4 py-6">
        <div className="flex items-center gap-2 mb-1">
          <CalendarCheck className="w-6 h-6 text-[#4bb3a5]" />
          <h1 className="text-xl font-bold text-[#1f2a37]">
            Morning Teer Calendar
          </h1>
        </div>
        <p className="text-sm text-gray-500 mb-6">
          Choose any date to view the Shillong Morning Teer result declared on
          that day.
        </p>

        <form
          onSubmit={search}
          className="flex flex-col sm:flex-row gap-3 items-start sm:items-end mb-8"
        >
          <div>
            <label className="block text-sm font-medium text-[#5b6b7b] mb-1">
              Select Date:
            </label>
            <input
              type="date"
              value={dateISO}
              onChange={(e) => setDateISO(e.target.value)}
              className="border border-gray-300 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#4a7fb5]"
            />
          </div>
          <button
            type="submit"
            className="inline-flex items-center gap-2 bg-[#4bb3a5] hover:bg-[#3f9d90] text-white font-medium px-6 py-2.5 rounded-md transition-colors"
          >
            <Search className="w-4 h-4" /> View Result
          </button>
        </form>

        {loading && <p className="text-gray-400">Searching...</p>}

        {!loading && result === null && (
          <div className="max-w-md mx-auto bg-[#fff4f2] border border-[#f3c4b4] rounded-md p-4 text-center text-sm text-[#a13b2a]">
            No result found for this date. It may be a holiday or the result has
            not been published yet.
          </div>
        )}

        {!loading && result && (
          <div className="border-2 border-black rounded-sm overflow-hidden max-w-md mx-auto">
            <div className="bg-[#e6e6e6] text-center py-2 text-lg font-medium border-b-2 border-black">
              SHILLONG · {result.date.replace(/-/g, "/")}
            </div>
            <div className="grid grid-cols-2">
              <div className="bg-[#7fd0b8] text-center py-2 font-semibold border-r-2 border-b-2 border-black">
                F/R
              </div>
              <div className="bg-[#7fd0b8] text-center py-2 font-semibold border-b-2 border-black">
                S/R
              </div>
              <div className="text-center py-3 text-2xl font-bold border-r-2 border-black">
                {result.fr}
              </div>
              <div className="text-center py-3 text-2xl font-bold">{result.sr}</div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default TeerCalendar;
